import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { DateValue, FlexBox } from '@dfl/mui-react-common';
import { IShipping } from 'modules/sales/common/interfaces/IOrder';
import { Chip, Stack, Typography } from '@mui/material';
import { HourglassEmptyOutlined } from '@mui/icons-material';

type Props = {
  value: IShipping;
};

const DeliveryDateCell = ({ value: data }: Props) => {
  const { t } = useTranslation('order');

  if (!data?.delivered || !data?.deliveryDate) {
    return (
      <FlexBox alignItems='center' gap={0.75}>
        <HourglassEmptyOutlined sx={{ fontSize: 15, color: 'warning.main' }} />
        <Typography variant='caption' color='warning.main' fontWeight={600} noWrap>
          {t('shipping.pendingDelivery')}
        </Typography>
      </FlexBox>
    );
  }

  const daysLate =
    data?.deliveryDateDifference !== undefined ? Math.ceil(data.deliveryDateDifference / 86400) : 0;
  const isLate = daysLate > 0;

  return (
    <Stack gap={0.5}>
      <DateValue value={data.deliveryDate} format='dd/MM/yyyy | hh:mm aa' />
      {
        isLate && (
          <Chip
            label={t('shipping.daysLate', { count: daysLate })}
            color='error'
            size='small'
            sx={{ height: 20, fontSize: 11, fontWeight: 300, width: 'fit-content' }}
          />
        )
      }
    </Stack >
  );
};

export default memo(DeliveryDateCell);
